import { useCallback, useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router'
import { useTheme } from '@mui/material'
import { useSnackbar } from 'notistack'

import FullScreenDrawer from '../../../components/full-screen-drawer'
import Api from '../../../utils/api'
import useIsMobile from '../../../utils/hooks/useIsMobile'

import Device from './device'
import DeviceDetailsMenu from './device-details-menu'
import classes from './index.styles'

const DeviceDetails = () => {
  const navigate = useNavigate()
  const { deviceId } = useParams<{ deviceId: string }>()

  const theme = useTheme()
  const isMobile = useIsMobile()

  const { enqueueSnackbar } = useSnackbar()
  const [device, setDevice] = useState<IDeviceType | null>(null)

  const fetchData = useCallback(async () => {
    if (!deviceId) return
    setDevice(null)
    const res = await Api.get(`/api/v2/protect/devices/${deviceId}?isActivating=false`)
    if (res.ok) {
      setDevice(res.body)
    } else {
      enqueueSnackbar('Failed to fetch device data', { variant: 'error' })
    }
  }, [deviceId, enqueueSnackbar])

  useEffect(() => {
    fetchData()
  }, [fetchData])

  if (isMobile) {
    return (
      <FullScreenDrawer
        open={true}
        title="Device Details"
        showCloseIcon={false}
        showBackIcon={true}
        rightIcon={<DeviceDetailsMenu device={device} refetchDevice={fetchData} />}
        onClose={() => {
          navigate(-1)
        }}
        modalPaperStyle={classes.modalPaperStyle(theme)}
        contentContainerSx={{ paddingTop: 0 }}
      >
        <Device device={device} refetchDevice={fetchData} />
      </FullScreenDrawer>
    )
  }

  return <Device device={device} refetchDevice={fetchData} />
}

export default DeviceDetails
